import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpGetAllCourses } from '../../Hooks/courses.hooks';
import PropTypes from 'prop-types';
import PageError from '../../Components/PageErrorState/PageErrorState';
import PageLoading from '../../Components/PageLoadingState/PageLoadingState';

const CoursesDataProvider = ({ children, admin = false }) => {
  const {
    data: courses,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['courses', admin],
    queryFn: () => httpGetAllCourses(admin),
    staleTime: 2 * 60 * 60 * 1000,
    retry: 5,
  });
  if (isLoading)
    return (
      <PageLoading
        title="Loading Courses..."
        description="Fetching courses for you."
      />
    );
  if (isError)
    return (
      <PageError
        title="Error Loading Courses"
        description="We were unable to load the courses. Please try again later."
      />
    );

  return children(courses);
};
CoursesDataProvider.propTypes = {
  children: PropTypes.func,
  admin: PropTypes.bool,
};

export default CoursesDataProvider;
